import React, { useState, useRef, useEffect } from 'react'
import { Collapse, Row, Col, Card, Button, Tooltip, Popconfirm, Table, Input, message } from 'antd'
import { chooseEmailModalFxn, DisplayDate, GetDownloadLink } from '../../../components/_utils/appUtils'
import ReactHtmlParser from 'react-html-parser'
import { RowTable, CustomCardTitle } from '../../article/articleView/RowTable'
import _ from 'lodash'
import { SendTemplateEmail } from '../../email/actions'
import { useDispatch } from 'react-redux'
import { getPushPathWrapper } from '../../../routes'
import AddCourierDrawer from '../drawer/addCourierDrawer'
import { TableComp } from 'sz-react-utils-lite'
import AddPaymentDrawer from '../drawer/addPaymentDrawer'
import Request from '../../../request'
import { apiUrl } from '../../../settings'
// Adding new imports :-
import EditPaymentDrawer from '../drawer/editPaymentDrawer'
import EditCourierDrawer from '../drawer/editCourierDrawer'
import EditGeneralSubscriptionDrawer from '../drawer/edit'
import { sendInvoiceReminderFxn } from '../action'

const { Panel } = Collapse


const GeneralSubscriptionDetails = (props) => {
  let {
    article,
    courierData
  } = props
  const [articleData, setArticleData] = useState(article)
  const dispatch = useDispatch()
  const [couriers, setCouriers] = useState(
    (article.courierDetails || []).sort((a, b) => new Date(b.date) - new Date(a.date))
  )
  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [missingIssue, setMissingIssue] = useState()
  const [visiblePaymentDrawer, setVisiblePaymentDrawer] = useState({
    visible: false,
    totalAmount: '',
    invoiceId: ''

  })
  const [state, setState] = useState({

    journalNameList: [],
    journalVolumeList: []

  })

  // NEW CODE 
  // const [isEditing, setIsEditing] = useState(false);
  // const [formData, setFormData] = useState(article);
  const [editPaymentVisible, setEditPaymentVisible] = useState(false)
  const [isAddJournalMode, setIsAddJournalMode] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState(null)
  const [editDrawerVisible, setEditDrawerVisible] = useState(false)
  const [selectedSubscription, setSelectedSubscription] = useState(null)


  const openEditPayment = (record) => {
    setSelectedPayment(record)
    setEditPaymentVisible(true)
  }

  // New Lines :-
  const [editCourierVisible, setEditCourierVisible] = useState(false)
  const [selectedCourier, setSelectedCourier] = useState(null)

  const openEditCourier = (record) => {
    setSelectedCourier(record)
    setEditCourierVisible(true)
  }
  // Ends
  const handleEditClick = (e) => {
    e.stopPropagation()
    setIsAddJournalMode(false)
    setEditDrawerVisible(true)
    setSelectedSubscription(article)
  }

  const handleAddJournalClick = (e) => {
    e.stopPropagation()
    // FIX: Pass the current subscription data explicitly first!
    setSelectedSubscription(article)
    setIsAddJournalMode(true)
    setEditDrawerVisible(true)
  }

  const handleReminder = async (record) => {
    let resp = await dispatch(sendInvoiceReminderFxn({ invoiceId: record._id }))
    if (resp && resp.success) {

    }
  }


  const closeEditDrawer = () => {
    setEditDrawerVisible(false)
    setSelectedSubscription(null)
    setIsAddJournalMode(false)
  }

  // useEffect(() => {
  //   setFormData(article);
  // }, [article]);

  // const toggleEdit = (e) => {
  //   e.stopPropagation();
  //   setIsEditing(!isEditing);
  //   setFormData(article);
  // };

  // const handleInputChange = (key, value) => {
  //   setFormData(prev => ({ ...prev, [key]: value }));
  // };

  // const handleSave = async (e) => {
  //   e.stopPropagation();
  //   if (props.onUpdate) {
  //     const success = await props.onUpdate(formData);
  //     if (success) setIsEditing(false);
  //   }
  // };

  const renderRow = (title, key, value) => {
    const isStatus = key === 'status'
    // const showInput = isEditing && !isStatus;
    return (
      <div className='row-table' style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ flex: 1, fontWeight: 'bold', color: '#555' }}>{title}</div>
        <div style={{ flex: 2 }}>
          <span style={isStatus ? { color: 'orange', fontWeight: 'bold' } : {}} className={'capText'}>
            {value || '--'}
          </span>
        </div>
      </div>
    )
  }

  const table = useRef()
  const events = {

    showDrawer: data => {
      setMissingIssue(data)
      setVisibleDrawer(true)
    },
    hideDrawer: data => {
      setMissingIssue('')
      setVisibleDrawer(false)

    },
    showPaymentDrawer: (data, _id) => {
      setVisiblePaymentDrawer({ visible: true, totalAmount: data, invoiceId: _id })
    },
    hidePaymentDrawer: data => {
      setVisiblePaymentDrawer({ visible: false, totalAmount: '', invoiceId: '' })

    },
    getJournalList: async () => {
      let { data } = await Request.journalName()
      let journalList = []
      _.each(data, item => {
        journalList.push({
          _id: item._id,
          value: item.slugJournal,
          display: item.name
        })
      })
      setState(prevState => ({
        ...prevState,
        journalNameList: journalList
      }))
    },

    getJournalsVolumeData: async () => {
      let { data } = await Request.getJournalsVolumeList()
      let volumeList = []
      _.each(data, (item) => {
        volumeList.push({
          _id: item._id,
          name: item.volumeName
        })
      })
      setState(prevState => ({
        ...prevState,
        journalVolumeList: volumeList
      }))
    }
  }
  useEffect(() => {
    events.getJournalList()
    events.getJournalsVolumeData()
  }, [])

  const handlePaymentAdded = (data) => {
    let updatedInvoiceStatus = articleData.invoiceData && articleData.invoiceData.status

    setArticleData({
      ...articleData,
      invoiceData: {
        status: updatedInvoiceStatus
      }
    })
    setVisiblePaymentDrawer({ visible: false })
  }
  let sendMailFxn = (article) => {
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          id: article._id,
          fromEmail: email,
          emailType: 'acknowledgement',
          template: article.processingCharges > 0 ? 'acknowledgementWithCharges' : 'acknowledgementWithoutCharges',
          type: 'article'
        }
        let resp = await dispatch(SendTemplateEmail({
          email: obj.fromEmail,
          id: article._id,
          obj,
          template: obj.template
        }))
        if (resp && resp.success) {
          dispatch({ type: 'START_LOAD_ARTICLE' })
        }
      }
    })
  }

  let BtnAction = (event) => {
    event.stopPropagation()
    sendMailFxn(article)
  }


  let getExtraButton = () => {
    return (
      <>
        <React.Fragment>

          <Button type={'primary'} size={'small'} onClick={(e) => {
            e.stopPropagation()
            events.showDrawer()
          }}>Add Courier</Button>
        </React.Fragment>
        <React.Fragment>


        </React.Fragment>

      </>

    )
  }
  let getMissingIssueButton = () => {
    return (
      <>
        <React.Fragment>

          <Button type={'primary'} size={'small'} onClick={(e) => {
            e.stopPropagation()
            events.showDrawer(true)
          }}>Add Missing Issues</Button>
        </React.Fragment>
        <React.Fragment>


        </React.Fragment>

      </>

    )
  }

  const getJournalColor = (journalId) => {

    const palette = [
      '#E6F7FF', // Light Blue
      '#F6FFED', // Light Green
      '#FFF1F0', // Light Red
      '#FFF7E6', // Light Orange
      '#F9F0FF', // Light Purple
      '#E6FFFB', // Light Cyan
      '#FFF0F6', // Light Magenta
      '#FCFFE6', // Light Lime
      '#E6F7FF', // Pale Blue
      '#F0F5FF', // Geek Blue
      '#FFF2E8', // Sunset Orange
      '#F4FFB8', // Lime Green
      '#D9F7BE', // Green
      '#B5F5EC', // Cyan
      '#EFDBFF', // Purple
      '#FFD6E7', // Magenta
      '#FFD8BF', // Salmon
      '#FFE58F', // Gold
      '#ffccc7', // Red
      '#d3f261'  // Yellow Green
    ]

    let hash = 0
    const idStr = (journalId && journalId.toString()) || ''
    if (!idStr) return '#ffffff'

    for (let i = 0; i < idStr.length; i++) {
      hash = idStr.charCodeAt(i) + ((hash << 5) - hash)
    }

    const index = Math.abs(hash) % palette.length
    return palette[index]
  }

  let tableColumn = [
    {
      title: 'Date',
      name: 'date',
      key: 'date',
      dataIndex: 'date',
      width: 150,
      render: data => {
        return DisplayDate(data)
      }
    },
    {
      title: 'Mode',
      name: 'mode',
      key: 'mode',
      dataIndex: 'mode',
      width: 120,
      render: data => {
        return data || '-'
      }
    },
    {
      title: 'Tracking No',
      name: 'TrackingNo',
      key: 'TrackingNo',
      dataIndex: 'TrackingNo',
      width: 150,
      render: data => {
        return data || '-'
      }
    },
    {
      title: 'Journal Name',
      name: 'courierDetails',
      key: 'journalName',
      dataIndex: 'courierDetails',
      width: 300,
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        return (
          <div style={{ margin: '-8px' }}>
            {courierDetailsArray.map((item, idx) => {
              const journalItem = state.journalNameList.find(j => j._id === item.journal)
              return (
                <div key={idx} style={{
                  padding: '8px',
                  backgroundColor: getJournalColor(item.journal),
                  borderBottom: idx < courierDetailsArray.length - 1 ? '1px solid #e8e8e8' : 'none'
                }}>
                  {journalItem ? journalItem.display : '-'}
                </div>
              )
            })}
          </div>
        )
      }
    },
    {
      title: 'Volume',
      name: 'courierDetails',
      key: 'volume',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        return (
          <div style={{ margin: '-8px' }}>
            {courierDetailsArray.map((item, idx) => (
              <div key={idx} style={{
                padding: '8px',
                backgroundColor: getJournalColor(item.journal),
                borderBottom: idx < courierDetailsArray.length - 1 ? '1px solid #e8e8e8' : 'none'
              }}>
                {item.volumeName || '-'}
              </div>
            ))}
          </div>
        )
      }
    },
    {
      title: 'Issues',
      name: 'courierDetails',
      key: 'issues',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        return (
          <div style={{ margin: '-8px' }}>
            {courierDetailsArray.map((item, idx) => (
              <div key={idx} style={{
                padding: '8px',
                backgroundColor: getJournalColor(item.journal),
                borderBottom: idx < courierDetailsArray.length - 1 ? '1px solid #e8e8e8' : 'none'
              }}>
                {Array.isArray(item.issues) ? item.issues.join(', ') : (item.issues || '-')}
              </div>
            ))}
          </div>
        )
      }
    },
    {
      title: 'Copies',
      name: 'courierDetails',
      key: 'copies',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        return (
          <div style={{ margin: '-8px' }}>
            {courierDetailsArray.map((item, idx) => (
              <div key={idx} style={{
                padding: '8px',
                backgroundColor: getJournalColor(item.journal),
                borderBottom: idx < courierDetailsArray.length - 1 ? '1px solid #e8e8e8' : 'none'
              }}>
                {item.copies || '-'}
              </div>
            ))}
          </div>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button icon='edit' size='small' onClick={(e) => {
          e.stopPropagation()
          openEditCourier(record)
        }}>
          Edit
        </Button>
      )
    }
  ]
  let paymentColumn = [
    {
      title: 'Received Date',
      name: 'receivedDate',
      key: 'receivedDate',
      dataIndex: 'receivedDate',
      width: 400,
      render: data => {
        return DisplayDate(data)
      }
    },

    {
      title: 'Receipt No',
      dataIndex: 'receiptNo',
      key: 'receiptNo',
      render: (text, record) => {
        if (!text) return '-'
        if (article && article.paymentDetails) {
          const invoicePayments = article.paymentDetails.filter(p => p.invoiceId === record.invoiceId)
          const index = invoicePayments.findIndex(p => p.receiptNo === text)
          if (index !== -1) {
            return index + 1
          }
        }
        return text
      }
    },

    {
      title: 'Mode Of Payment',
      name: 'modeOfPayment',
      key: 'modeOfPayment',
      dataIndex: 'modeOfPayment'
    },
    {
      title: 'Transaction/Cheque ID',
      name: 'transactionId',
      key: 'transactionId',
      dataIndex: 'transactionId',
      render: data => {
        return data || '-'
      }
    },
    {
      title: 'Amount',
      name: 'amount',
      key: 'amount',
      dataIndex: 'amount'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button icon='edit' size='small' onClick={(e) => {
          e.stopPropagation()
          openEditPayment(record)
        }}>
          Edit
        </Button>
      )
    }
  ]
  let invoiceColumn = [
    {
      title: 'Invoice Date',
      name: 'date',
      key: 'date',
      dataIndex: 'date',
      width: 400,
      render: data => {
        return DisplayDate(data)
      }
    },
    {
      title: 'Invoice No',
      name: 'invoiceNo',
      key: 'invoiceNo',
      dataIndex: 'invoiceNo'
    },
    {
      title: 'Invoice Status',
      name: 'status',
      key: 'status',
      dataIndex: 'status',
      render: (item) => {
        return (
          <span className={'capText'}>{item}</span>
        )
      }
    },
    {
      title: 'Receipt Number',
      key: 'receiptNo',
      render: (text, record) => {
        const matchingPayments = article.paymentDetails
          ? article.paymentDetails.filter(payment => payment.invoiceId === record._id)
          : []

        // If any matching payment has a receiptNo, show "1"
        const hasReceipt = matchingPayments.some(p => p.receiptNo)
        return hasReceipt ? '1' : '-'
      }
    },

    {
      title: 'Invoice',
      name: 'invoice',
      key: 'invoice',
      width: 200,
      render: (val, record) => {
        // Direct link to backend PDF download endpoint
        const pdfUrl = `${apiUrl}/downloadInvoice/${record._id}`
        return (
          <a href={pdfUrl} target='_blank' rel='noopener noreferrer'>
            Download Invoice
          </a>
        )
      }
    },
    {
      title: 'Receipt',
      key: 'downloadReceipt',
      render: (text, record) => {
        const matchingPayments = article.paymentDetails
          ? article.paymentDetails.filter(payment => payment.invoiceId === record._id)
          : []
        const hasReceipt = matchingPayments.some(p => p.receiptNo)

        if (hasReceipt) {
          return (
            <a
              href={`${apiUrl}/api/receipt/download/${article._id}/${record._id}`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: 'blue', textDecoration: 'underline' }}
            >
              Download Receipt
            </a>
          )
        }
        return null
      }
    },

    {
      key: 'actions',
      title: 'Actions',
      width: 180,
      render: (val, record) => {
        const matchingPayments = (article && article.paymentDetails)
          ? article.paymentDetails.filter(payment => payment.invoiceId === record._id)
          : []
        const hasPayment = matchingPayments.length > 0

        return (
          <div style={{ display: 'flex', gap: '5px' }}>
            {record.status != 'done' && (
              <>
                <Button
                  type='primary'
                  size='small'
                  onClick={() => {
                    events.showPaymentDrawer(record && record.totalAmount, record._id)
                  }}
                >
                  Add Payment
                </Button>
                <Popconfirm
                  title={`Are you Sure, You want send reminder?`}
                  onConfirm={e => {
                    handleReminder(record)
                  }}
                  okText='Yes'
                  cancelText='No'>
                  <Button
                    type='primary'
                    size='small'>
                    Reminder
                  </Button>
                </Popconfirm>

              </>
            )}

          </div>
        )
      }
    }
  ]
  return (
    <>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
        {/* Added new line */}
        {/* <Panel header='General Subscription Details' key='1' expandIconPosition='right' extra={
          !isEditing ? (
            <Button type="primary" size="small" onClick={toggleEdit}>Edit</Button>
          ) : (
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button size="small" onClick={toggleEdit}>Cancel</Button>
              <Button type="primary" size="small" onClick={handleSave}>Save</Button>
            </div>
          )
        }> */}

        <Panel
          header='Journal Subscription Details'
          key='1'
          expandIconPosition='right'
          extra={
            <Button type='primary' size='small' onClick={handleEditClick}>
              Edit
            </Button>
          }
        >

          <div className={'tableBox striped'} style={{ padding: '10px' }}>

            {renderRow(
              ['Institute', 'Agency', 'Library', 'University'].includes(article.subscribeBy)
                ? `${article.subscribeBy} Name`
                : 'Name',
              'name',
              article.name
            )}


            {article.contactPerson && renderRow('Contact Person', 'contactPerson', article.contactPerson)}


            {article.instituteContactPerson && renderRow(
              `${article.subscribeBy || 'Institute'} Contact Person`,
              'instituteContactPerson',
              article.instituteContactPerson
            )}

            {renderRow('Primary Email', 'email', article.email)}

            {article.secondaryEmail && renderRow('Secondary Email', 'secondaryEmail', article.secondaryEmail)}

            {renderRow('Primary Mobile', 'mobile', article.mobile)}

            {article.secondaryMobile && renderRow('Secondary Mobile', 'secondaryMobile', article.secondaryMobile)}

            {renderRow('Address', 'address', article.address)}

            {article.designation && renderRow('Designation', 'designation', article.designation)}

            {article.agencyName && renderRow('Agency Name', 'agencyName', article.agencyName)}

            {renderRow('Pincode', 'pincode', article.pincode)}
            {renderRow('Country', 'country', article.country)}
            {renderRow('State', 'state', article.state)}
            {renderRow('City', 'city', article.city)}
            {renderRow('Page Number', 'pageNumber', article.pageNumber)}
            {renderRow('Year', 'year', article.year)}
            {renderRow('Subscribe By', 'subscribeBy', article.subscribeBy)}
            {renderRow('Status', 'status', article.status)}


            {article.instituteAddress && renderRow('Institute Address', 'instituteAddress', article.instituteAddress)}
            {article.instituteContactNo && renderRow('Institute Contact No', 'instituteContactNo', article.instituteContactNo)}
          </div>

        </Panel>

        <Panel header='Invoice Details' expandIconPosition='right' extra={
          <Button type='primary' size='small' onClick={handleAddJournalClick}>
            Generate Invoice
          </Button>
        }>
          <div className={'tableBox striped'}>
            {/*<RowTable title={'Invoice Date'} value={DisplayDate(article.invoiceData && article.invoiceData.date)} />*/}

            {/*<RowTable*/}
            {/*  title="Invoice"*/}
            {/*  value={*/}
            {/*    <>*/}

            {/*      {article &&*/}
            {/*      article &&*/}
            {/*      article.invoice &&*/}
            {/*      article.invoice.path && (*/}
            {/*        <a*/}
            {/*          href={article.invoice.path}*/}
            {/*          target="_blank"*/}
            {/*          rel="noopener noreferrer"*/}
            {/*          className="ml20"*/}
            {/*        >*/}
            {/*          Download Invoice*/}
            {/*        </a>*/}
            {/*      )}*/}
            {/*    </>*/}
            {/*  }*/}
            {/*/>*/}
            {/*<RowTable title={'Invoice Status'} value={article.invoiceData && article.invoiceData.status} />*/}
            <TableComp
              className='figureTable'
              bordered
              pagination={false}
              columns={invoiceColumn}
              dataSource={article.invoiceData
              }
            />
          </div>

        </Panel>
        <Panel header='Payment Details'>

          <div className={'tableBox striped'}>
            <TableComp
              className='figureTable'
              bordered
              pagination={false}
              columns={paymentColumn}
              dataSource={(article.paymentDetails || []).sort((a, b) => new Date(b.receivedDate) - new Date(a.receivedDate))}
            />

            {/*<RowTable title={'Received Date'}  value={`${ DisplayDate(article.receivedDate) } `}  />*/}
            {/*<RowTable title={'Mode Of Payment'}  value={`${ article.modeOfPayment } `}  />*/}
            {/*<RowTable title={'Amount'}  value={`INR ${ article.totalAmount } `}  />*/}
          </div>

        </Panel>
        <Panel header='Courier Details' extra={getExtraButton()}>

          <TableComp
            className='figureTable'
            bordered
            pagination={false}
            columns={tableColumn}
            dataSource={(courierData || [])
              .filter(item => !item.missingIssues)
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            }
          />
        </Panel>
        <Panel header='Missing Issues' extra={getMissingIssueButton()}>

          <TableComp
            className='figureTable'
            bordered
            pagination={false}
            columns={tableColumn}
            dataSource={(courierData || [])
              .filter(item => item.missingIssues)
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            }
          />
        </Panel>
      </Collapse>
      {visibleDrawer && (
        <AddCourierDrawer visible={visibleDrawer} reloadData={props.reloadData} invoiceData={article.invoiceData}
                          allJournals={article.allJournals}
                          record={article}
                          missingIssues={missingIssue}
                          onClose={() => setVisibleDrawer(false)} />
      )}

      {visiblePaymentDrawer.visible && (
        <AddPaymentDrawer      {...visiblePaymentDrawer}
                               _id={article._id}
                               reloadData={props.reloadData}
                               onPaymentAdded={handlePaymentAdded}
                               onClose={() => events.hidePaymentDrawer()} />
      )}

      <EditPaymentDrawer
        visible={editPaymentVisible}
        data={selectedPayment}
        subscriptionId={article._id}
        onClose={() => setEditPaymentVisible(false)}
        onSuccess={props.reloadData}
      />

      <EditCourierDrawer
        visible={editCourierVisible}
        data={selectedCourier}
        onClose={() => setEditCourierVisible(false)}
        onSuccess={props.reloadData}
      />
      <EditGeneralSubscriptionDrawer
        visible={editDrawerVisible}
        onClose={closeEditDrawer}
        record={selectedSubscription}
        dispatch={dispatch}
        onSuccess={props.reloadData}
        showAddJournal={isAddJournalMode}
      />
    </>

  )

}

export default GeneralSubscriptionDetails
